import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({
  isAuthenticated, redirectPath, children, ...rest
}) => (
  <Route
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
    render={({ location }) => (isAuthenticated ? (
      children
    ) : (
      <Redirect
        to={{
          pathname: redirectPath,
          state: { from: location },
        }}
      />
    ))}
  />
);

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,

  isAuthenticated: PropTypes.bool,
  redirectPath: PropTypes.string,
};

PrivateRoute.defaultProps = {
  isAuthenticated: false,
  redirectPath: '/login',
};

export default PrivateRoute;
